<template>
  <div class="card-block" id="statementSection">
    <h3 class="card-title">
      {{ $t("statement.labels.statement") }}
    </h3>
    <div class="row" v-if="isLoading">
      <div class="col-md-12 card-stat">
        <loading-indicator></loading-indicator>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <div class="p-t-15">
          <div class="row">
            <div class="col-xs-2 col-md-3">
              <div class="form-group">
                <select id="filteringStatus" class="form-control" v-model="currentYear" v-on:change="onChange()">
                  <option v-for="(year, index) in yearList" v-bind:value="year">{{year}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-striped table-hover table-responsive" v-if="havaTransactions">
              <table class="table is-indent">
                <thead>
                  <tr>
                    <th class="cell-80">{{ $t("unit.date") }}</th>
                    <th class="cell-150" scope="col">{{ $t("statement.labels.orderNumber") }}</th>
                    <th class="cell-150" scope="col">{{ $t("statement.labels.invoiceNumber") }}</th>
                    <th class="cell-150" scope="col">{{ $t("statement.labels.receiptNumber") }}</th>
                    <th class="cell-200" scope="col">{{ $t("statement.labels.description") }}</th>
                    <th class="cell-100 text-xs-right" scope="col">{{ $t("statement.labels.amount") }}</th>
                    <th class="cell-150 text-xs-right"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in transactions.data">
                    <td class="cell-80">
                      <span :title="getFullHistoryDate(item.created_at)">{{getHistoryDate(item.created_at)}}</span>
                    </td>
                    <td class="cell-150">
                      <router-link v-bind:to="urlOrderNumberReport(item.order_number)" class="btn btn-link" v-if="item.order_number"> {{ item.order_number }}
                      </router-link>
                      <span v-else class="text-xs-center">-</span>
                    </td>
                    <td class="cell-150">
                      {{item.invoice_number ? item.invoice_number : '-'}}
                    </td>
                    <td class="cell-150">
                      {{item.receipt_number ? item.receipt_number : '-'}}
                    </td>
                    <td class="cell-200">
                      <p class="m-b-0">{{item.source}}</p>
                      <p class="m-b-0 font-size-12 grey-500">{{item.description}}</p>
                      <p class="m-b-0 font-size-12 grey-500" v-if="item.note">Admin note - {{item.note}}</p>
                    </td>
                    <td class="cell-100 text-xs-right">
                      <span class="green-600" v-if="item.amount > 0">{{item.human_amount}} {{ $t("billing.currencies.thb") }}</span>
                      <span class="red-600" v-else-if="item.amount < 0">
                        {{item.human_amount}} {{ $t("billing.currencies.thb") }}
                      </span>
                      <span v-else>{{item.human_amount}} {{ $t("billing.currencies.thb") }}</span>
                    </td>
                    <td class="cell-150 text-xs-right">
                      <a class="btn btn-sm btn-icon btn-default" :href="`${item.download_url}`"
                      v-if="false" download>
                        {{ $t("statement.action.download") }}
                      </a>
                      <router-link v-bind:to="urlUsageReport(item.month)" class="btn btn-sm btn-icon btn-default" v-if="item.source_type === 'System' && month"> {{ $t("statement.action.download") }}
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="alert alert-primary alert-dismissible" v-else>
              {{ $t("statement.labels.noBillingHistory") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    LoadingIndicator,
  },
  props: {
    team: {
      type: Object,
    },
  },
  watch: {
    team: function(value) {
      if (value) {
        this.fetchTransaction(this.currentYear);
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    baseURL: function() {
      return process.env.BASE_URL;
    },
    yearList: function() {
      const list = [];

      const now = moment().startOf('years');
      const start = moment(this.team.created_at).startOf('years');
      const years = (now.diff(start, 'years'));
      list.push(now.format('YYYY'));

      for (let i = 0; i < years; i += 1) {
        list.push(now.subtract(1, 'years').format('YYYY'));
      }

      return list;
    },
    havaTransactions: function() {
      return (this.transactions.data && this.transactions.data.length > 0);
    },
    downLoadUrl: function() {
      if (this.team && this.currentUser) {
        if (this.$route.params.subnamespace) {
          const parentUrl = this.$route.params.namespace;
          const namespace = this.$route.params.subnamespace;

          let role;

          if (this.currentUser.team.is_superadmin) {
            role = 'admin';
          } else if (this.currentUser.team.is_reseller) {
            role = 'reseller';
          }

          return `/${parentUrl}/${role}/teams/${namespace}`;
        } else {
          const namespace = this.$route.params.namespace;
          return `/${namespace}`;
        }
      }
    },
  },
  data: function () {
    return {
      isLoading: false,
      transactions: null,
      currentYear: moment().format('YYYY'),
    };
  },
  created: function() {
    this.isLoading = true;

    this.$emit('loadChanged', true);

    this.eventHub.$on('manualAddCreditSuccess', () => {
      this.fetchTransaction(this.currentYear);
    });
  },
  mounted: function() {
    if (this.team) {
      this.fetchTransaction(this.currentYear);
    }
  },
  methods: {
    fetchTransaction: function(year) {
      const namespace = this.team.namespace;

      if (!year) {
        year = moment(this.currentMonth, ['YYYY', moment.ISO_8601]).format('YYYY');
      } else {
        year = moment(year, ['YYYY', moment.ISO_8601]).format('YYYY');
      }

      axios.get(`/api/teams/${namespace}/balances/transaction?year=${year}`)
      .then((response) => {
        this.transactions = response.data;
        this.isLoading = false;

        this.$emit('loadChanged', false);
      })
      .catch(() => {
        this.isLoading = false;

        this.$emit('loadChanged', false);
      });
    },
    getHistoryDate: function (date) {
      return moment(date, ['YYYY-MM-DD', moment.ISO_8601]).format('D MMM YYYY');
    },
    getFullHistoryDate: function (date) {
      return moment(date, ['YYYY-MM-DD HH:mm', moment.ISO_8601]).format('D MMM YYYY HH:mm');
    },
    urlUsageReport: function (month) {
      if (!month) {
        month = moment(this.currentMonth, ['MMMM YYYY', moment.ISO_8601]).format('YYYY-MM');
      } else {
        month = moment(month, ['YYYY-MM-DD HH:mm', moment.ISO_8601]).format('YYYY-MM');
      }

      return `${this.downLoadUrl}/usage-report?month=${month}`;
    },
    urlOrderNumberReport: function (number) {
      if (number) {
        return `${this.downLoadUrl}/transactions?number=${number}`;
      }
      return '';
    },
    onChange: function () {
      this.fetchTransaction(this.currentYear);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Statement.vue?6b57cdc8